import { API_VERSION } from 'constants/api'
import { getClientAndAPIKey } from 'utils/actionsHelper'

export const GET_MESSAGE_COST_REQUEST = 'GET_MESSAGE_COST_REQUEST'
export const GET_MESSAGE_COST_SUCCESS = 'GET_MESSAGE_COST_SUCCESS'
export const GET_MESSAGE_COST_FAILURE = 'GET_MESSAGE_COST_FAILURE'

export const POST_TEXT_MESSAGE_REQUEST = 'POST_TEXT_MESSAGE_REQUEST'
export const POST_TEXT_MESSAGE_SUCCESS = 'POST_TEXT_MESSAGE_SUCCESS'
export const POST_TEXT_MESSAGE_FAILURE = 'POST_TEXT_MESSAGE_FAILURE'

export function getMessageCost(appointmentId, messageType, onSuccess = () => {}) {
  const { client } = getClientAndAPIKey()
  const params = `?appointment_id=${appointmentId}&message_type=${messageType}`
  return {
    types: [
      GET_MESSAGE_COST_REQUEST,
      GET_MESSAGE_COST_SUCCESS,
      GET_MESSAGE_COST_FAILURE
    ],
    method: 'GET',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/messages/cost${params}`,
    onSuccess
  }
}

export function sendTextMessage(appointmentId, text, onSuccess = () => {}) {
  const { client } = getClientAndAPIKey()
  return {
    types: [
      POST_TEXT_MESSAGE_REQUEST,
      POST_TEXT_MESSAGE_SUCCESS,
      POST_TEXT_MESSAGE_FAILURE
    ],
    method: 'POST',
    url: `${process.env.GVS_URL}/api/client/${API_VERSION}/${client}/messages/text`,
    body: {
      appointment_id: appointmentId,
      message: text
    },
    onSuccess
  }
}
